import { IS_USE_CENTIMETERS_SIZE_COUNTRY } from './is-use-centimeters-size-country';
import { sizeMap } from './size-map';

export const sizeList = [
  {
    size: sizeMap['0'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '81.28' : '32',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '64.77' : '25½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '90.17' : '35½',
  },
  {
    size: sizeMap['2'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '83.82' : '33',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '67.31' : '26½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '92.71' : '36½',
  },
  {
    size: sizeMap['4'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '86.36' : '34',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '69.85' : '27½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '95.25' : '37½',
  },
  {
    size: sizeMap['6'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '88.9' : '35',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '72.39' : '28½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '97.79' : '38½',
  },
  {
    size: sizeMap['8'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '91.44' : '36',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '74.93' : '29½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '100.33' : '39½',
  },
  {
    size: sizeMap['10'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '95.25' : '37½',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '78.74' : '31',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '104.14' : '41',
  },
  {
    size: sizeMap['12'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '99.06' : '39',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '82.55' : '32½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '107.95' : '42½',
  },
  {
    size: sizeMap['14'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '104.14' : '41',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '88.265' : '34¾',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '113.03' : '44½',
  },
  {
    size: sizeMap['16'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '109.855' : '43¼',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '94.615' : '37¼',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '118.745' : '46¾',
  },
  {
    size: sizeMap['18'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '115.57' : '45½',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '100.965' : '39¾',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '124.46' : '49',
  },
  {
    size: sizeMap['20'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '121.285' : '47¾',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '107.315' : '42¼',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '130.81' : '51½',
  },
  {
    size: sizeMap['22'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '127' : '50',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '113.665' : '44¾',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '135.89' : '53½',
  },
  {
    size: sizeMap['24'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '134.62' : '53',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '121.92' : '48',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '143.51' : '56½',
  },
  {
    size: sizeMap['26'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '142.24' : '56',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '130.175' : '51¼',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '150.495' : '59¼',
  },
  {
    size: sizeMap['28'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '149.86' : '59',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '138.43' : '54½',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '158.75' : '62½',
  },
  {
    size: sizeMap['30'],
    bust: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '160.02' : '63',
    waist: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '149.225' : '58¾',
    hip: IS_USE_CENTIMETERS_SIZE_COUNTRY ? '168.91' : '66½',
  },
];
